import { request } from '@tencent/ppd-base-libs';
import { Tab, Banner, Project, Organ } from '@/types';
import moment from 'moment';

/** 统一格式配置的时间字段 */
function formatTimeStr(str: string) {
  if (!str) return '';
  return str.replace(/-/g, '/');
}

/**
 * 获取慈善页面前端配置
 */
export function getCharityCfg() {
  return request.loadConfig('//st.moneydata.hk/res/cc/charityConfig/config.json');
}

/**
 * 格式化配置
 */
export async function getFormatedCharityCfg() {
  const rawCfg = await getCharityCfg();

  const {
    charityTabConfig = [],
    charityBannerConfig = [],
    charityProjectConfig = [],
    charityOrganizationConfig = [],
  } = rawCfg;

  // tab配置
  const tabCfg = charityTabConfig;
  // banner配置
  const bannerCfg = fmtBannerCfg(charityBannerConfig);
  // 项目配置
  const projectCfg = fmtProjectCfg(charityProjectConfig);
  // 组织配置
  const organCfg: Organ = charityOrganizationConfig;
  return {
    tabCfg,
    bannerCfg,
    projectCfg,
    organCfg,
  };
}

/**
 * 格式化banner配置
 */
function fmtBannerCfg(rBannerCfgArr): Banner[] {
  const bannerCfgArr = rBannerCfgArr.map((banner) => {
    const { img, href, sort, time } = banner;

    let startTime; let endTime;

    if (time[0]) {
      const { startTime: sTime, endTime: eTime } = time[0];
      startTime = moment(new Date(formatTimeStr(sTime))).toDate();
      endTime = moment(new Date(formatTimeStr(eTime))).toDate();
    }

    return {
      img,
      href,
      startTime,
      endTime,
      sort,
    };
  });

  return bannerCfgArr;
}

/**
 * 格式化项目配置
 */
function fmtProjectCfg(rProjectCfgArr): Project[] {
  const projectCfgArr = rProjectCfgArr.map((project) => {
    const {
      lowAmount = 0.1, // 最低0.1元
      amountOptions: rAmountOptions,
      isDisplayOnIndex: isShow = 1,
      time,
      state,
      tabId,
      isNineProj,
      donateBtnType,
    } = project;

    let startTime; let endTime;

    if (time[0]) {
      const { startTime: sTime, endTime: eTime } = time[0];
      startTime = moment(new Date(formatTimeStr(sTime))).toDate();
      endTime = moment(new Date(formatTimeStr(eTime))).toDate();
    }

    const amountOptions = rAmountOptions.map((option) => {
      const { amount, desc } = option;
      return {
        amount: +amount,
        desc,
      };
    });

    return {
      ...project,
      lowAmount,
      donateBtnType: +donateBtnType,
      amountOptions,
      isDisplayOnIndex: +isShow === 1,
      startTime,
      endTime,
      isOnline: +state === 1,
      tabIds: tabId.split(','),
      isNineProj: +isNineProj === 1,
    };
  });

  return projectCfgArr;
}
